import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import { REACT_APP_API_URL } from "../env";
import { useSelector } from "react-redux";

function Newfooter() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [visitorCount, setVisitorCount] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const isAuthenticated = !!(user && user.EmailId);

  const validateEmail = (input) => {
    const sanitized = input
      .replace(/[<>"'`;(){}]/g, "")
      .trim()
      .toLowerCase();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(sanitized) ? sanitized : null;
  };

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();

    if (isAuthenticated) {
      setMessage("You're already subscribed with your account email.");
      setMessageType("info");
      setSubmitted(true);
      return;
    }

    const rawEmail = email.replace(/[<>"'`;(){}]/g, "");
    const sanitizedEmail = validateEmail(rawEmail);

    if (!sanitizedEmail) {
      setMessage("Please enter a valid email address.");
      setMessageType("error");
      setSubmitted(true);
      return;
    }

    if (sanitizedEmail.length > 100) {
      setMessage("Email is too long.");
      setMessageType("error");
      setSubmitted(true);
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await axios.post(
        `${REACT_APP_API_URL}/api/newsletter/subscribe`,
        {
          email: sanitizedEmail,
        }
      );

      if (
        response?.data?.message?.toLowerCase().includes("already subscribed")
      ) {
        setMessage("You're already subscribed.");
        setMessageType("error");
        setEmail("");
      } else {
        setMessage("Subscribed successfully!");
        setMessageType("success");
        setEmail("");
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || "Subscription failed. Try again.";
      setMessage(errMsg);
      setMessageType("error");
    } finally {
      setIsSubmitting(false);
      setSubmitted(true);
    }
  };

  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => setSubmitted(false), 4000);
      return () => clearTimeout(timer);
    }
  }, [submitted]);

  useEffect(() => {
    const incrementVisitor = async () => {
      try {
        const response = await axios.post(
          `${REACT_APP_API_URL}/api/visitor/increment`
        );
        if (response?.data?.success) {
          setVisitorCount(response.data.count);
        }
      } catch (err) {
        console.error('Visitor counter error:', err);
      }
    };
    incrementVisitor();
  }, []);

  return (
    <footer
      className="main-footer bgs-cover overlay rel z-1 pb-25"
      style={{
        backgroundImage: "url(assets/images/backgrounds/footer.jpg)",
      }}
    >
      <div className="container">
        <div className="footer-top pt-40">
          <div className="row justify-content-between">
            <div className="col-xl-5 col-lg-6">
              <div className="footer-widget footer-text text-center">
                <div className="footer-logo mb-5">
                  <Link to="/">
                    <img
                      src="/images/logo/Logosforwebsite.webp"
                      alt="Logo"
                      style={{ height: "100px" }}
                      loading="lazy"
                    />
                  </Link>
                </div>

                <p className="text-white">
                  We make your Jharkhand trip smooth and enjoyable, with easy
                  hotel booking and hidden gems waiting to be explored.
                </p>
                <div className="social-style-one mt-15 d-flex justify-content-center text-center w-100 flex-wrap">
                  <a
                    href="https://www.facebook.com/share/19EuVmtjF1/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/icons/facebook.svg"
                      alt="Facebook"
                      style={{
                        width: "28px",
                        height: "28px",
                        objectFit: "contain",
                        margin: "0 8px",
                        background: "none",
                      }}
                    />
                  </a>

                  <a
                    href="https://www.instagram.com/jharkhandtourism/?hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/icons/instagram.svg"
                      alt="Instagram"
                      style={{
                        width: "28px",
                        height: "28px",
                        objectFit: "contain",
                        margin: "0 8px",
                        background: "none",
                      }}
                    />
                  </a>

                  <a
                    href="https://www.youtube.com/@JharkhandTourism"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/icons/youtube.svg"
                      alt="YouTube"
                      style={{
                        width: "28px",
                        height: "28px",
                        objectFit: "contain",
                        margin: "0 8px",
                        background: "none",
                      }}
                    />
                  </a>

                  <a
                    href="https://in.pinterest.com/tourismjharkhand234/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/icons/pinterest.svg"
                      alt="Pinterest"
                      style={{
                        width: "28px",
                        height: "28px",
                        objectFit: "contain",
                        margin: "0 8px",
                        background: "none",
                      }}
                    />
                  </a>

                  <a
                    href="https://x.com/VisitJharkhand"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/icons/twitter.svg"
                      alt="Twitter"
                      style={{
                        width: "28px",
                        height: "28px",
                        objectFit: "contain",
                        margin: "0 8px",
                        background: "none",
                      }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6 mt-0 mt-lg-4">
              <div className="section-title text-white mb-35">
                <h2
                  className="text-white newsLetter"
                  style={{
                    color: "#ffb347",
                    marginBottom: "15px",
                    fontWeight: "bold",
                    fontSize: "2rem",
                    fontFamily: "'EB Garamond', serif",
                    letterSpacing: "1px",
                    fontStyle: "italic",
                  }}
                >
                  Subscribe to the newsletter
                </h2>

                <p className="text-white">
                  {isAuthenticated
                    ? "You're already subscribed with your account email."
                    : "Most popular experience you'll remember"}
                </p>
              </div>
              <form
                className="newsletter-form mb-50"
                onSubmit={handleNewsletterSubmit}
              >
                <input
                  id="news-email"
                  type="email"
                  placeholder="Email Address"
                  required
                  value={email}
                  onChange={(e) =>
                    setEmail(e.target.value.replace(/[<>"'`;(){}]/g, ""))
                  }
                  maxLength={100}
                  autoComplete="off"
                  disabled={isAuthenticated || isSubmitting}
                  className={`newsletter-input ${isAuthenticated || isSubmitting
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                    }`}
                  style={{
                    borderColor:
                      messageType === "error"
                        ? "red"
                        : messageType === "success"
                          ? "green"
                          : "#ccc",
                    color: messageType === "error" ? "red" : "#000",
                  }}
                />
                {!submitted ? (
                  <button
                    type="submit"
                    className={`${isAuthenticated || isSubmitting
                      ? "cursor-not-allowed"
                      : ""
                      }`}
                    disabled={isAuthenticated || isSubmitting}
                    style={{
                      background: "linear-gradient(135deg, #ff7a00, #ffb347)",
                      color: "white",
                      fontSize: "1.1rem",
                      fontWeight: "500",
                      border: "none",
                      padding: "12px 26px",
                      borderRadius: "50px",
                      boxShadow: "0 6px 15px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease",
                      position: "relative",
                      overflow: "hidden",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      opacity: isAuthenticated || isSubmitting ? 0.5 : 1,
                      cursor:
                        isAuthenticated || isSubmitting
                          ? "not-allowed"
                          : "pointer",
                    }}
                    onMouseEnter={(e) => {
                      if (!(isAuthenticated || isSubmitting)) {
                        e.currentTarget.style.color = "#000000";
                        e.currentTarget.style.boxShadow =
                          "0 8px 20px rgba(0, 0, 0, 0.2)";
                        e.currentTarget.style.transform = "translateY(-2px)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!(isAuthenticated || isSubmitting)) {
                        e.currentTarget.style.color = "white";
                        e.currentTarget.style.boxShadow =
                          "0 6px 15px rgba(0, 0, 0, 0.1)";
                        e.currentTarget.style.transform = "translateY(0)";
                      }
                    }}
                  >
                    {isAuthenticated
                      ? "Subscribed"
                      : isSubmitting
                        ? "Subscribing..."
                        : "Subscribe"}
                  </button>
                ) : (
                  message && (
                    <div
                      style={{
                        color:
                          messageType === "error"
                            ? "red"
                            : messageType === "info"
                              ? "white"
                              : "lightgreen",
                        marginTop: 4,
                        fontSize: "0.75rem",
                        transition: "opacity 0.3s ease",
                      }}
                    >
                      {message}
                    </div>
                  )
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="widget-area pt-30 pb-10">
        <div
          className="container"
          style={{
            paddingLeft: window.innerWidth <= 768 ? "18px" : "",
            paddingRight: window.innerWidth <= 768 ? "18px" : "",
          }}
        >
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3 row-cols-xl-5 g-4 g-lg-5">

            {/* Embedded Map */}
            <div className="col">
              <div
                className="footer-widget"
                style={{
                  height: "100%",
                  paddingBottom: window.innerWidth <= 768 ? "10px" : "0px",
                }}
              >
                <div className="footer-title">
                  <h5
                    style={{
                      marginBottom: "15px",
                      fontWeight: "bold",
                      fontSize: window.innerWidth <= 768 ? "1.05rem" : "1.3rem",
                      fontFamily: "'EB Garamond', serif",
                      letterSpacing: "1px",
                      fontStyle: "italic",
                    }}
                  >
                    Visit Us
                  </h5>
                </div>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3664.533674657575!2d85.2932081!3d23.2963882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f51f467bc3362f%3A0xe53e6365c9fdeed9!2sJTDCL!5e0!3m2!1sen!2sin!4v1783756966435!5m2!1sen!2sin"
                  loading="lazy"
                  allowFullScreen
                  style={{
                    border: 0,
                    width: "100%",
                    height: window.innerWidth <= 768 ? "160px" : "180px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                  }}
                />
              </div>
            </div>

            {/* Tourist Services */}
            <div className="col">
              <div
                className="footer-widget footer-links"
                style={{
                  height: "100%",
                  paddingBottom: window.innerWidth <= 768 ? "10px" : "0px",
                }}
              >
                <div className="footer-title">
                  <h5
                    style={{
                      marginBottom: "15px",
                      fontWeight: "bold",
                      fontSize: window.innerWidth <= 768 ? "1.05rem" : "1.3rem",
                      fontFamily: "'EB Garamond', serif",
                      letterSpacing: "1px",
                      fontStyle: "italic",
                    }}
                  >
                    Tourist Services
                  </h5>
                </div>
                <ul className="list-style-three">
                  <li>
                    <Link to="/allhotel">Hotel Booking</Link>
                  </li>
                  <li>
                    <Link to="/advanceBooking">Package Booking</Link>
                  </li>
                  <li>
                    <a
                      href="/pdfs/vehicle-tariff.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Vehicle Booking Tariff (pdf)
                    </a>
                  </li>
                  <li>
                    <Link to="/events">Events</Link>
                  </li>
                  <li>
                    <Link to="/tours">Tours</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Popular Categories */}
            <div className="col">
              <div
                className="footer-widget footer-links"
                style={{
                  height: "100%",
                  paddingBottom: window.innerWidth <= 768 ? "10px" : "0px",
                }}
              >
                <div className="footer-title">
                  <h5
                    style={{
                      marginBottom: "15px",
                      fontWeight: "bold",
                      fontSize: window.innerWidth <= 768 ? "1.05rem" : "1.3rem",
                      fontFamily: "'EB Garamond', serif",
                      letterSpacing: "1px",
                      fontStyle: "italic",
                    }}
                  >
                    Experiences
                  </h5>
                </div>
                <ul className="list-style-three">
                  <li>
                    <Link to="/About">About Us</Link>
                  </li>
                  <li>
                    <Link to="/tenders">Tenders</Link>
                  </li>
                  <li>
                    <Link to="/careers">Careers</Link>
                  </li>
                  <li>
                    <Link to="/notice">Notices</Link>
                  </li>
                  <li>
                    <Link to="/cancellation-policy">Cancellation Policy</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col">
              <div
                className="footer-widget footer-links"
                style={{
                  height: "100%",
                  paddingBottom: window.innerWidth <= 768 ? "10px" : "0px",
                }}
              >
                <div className="footer-title">
                  <h5
                    style={{
                      marginBottom: "15px",
                      fontWeight: "bold",
                      fontSize: window.innerWidth <= 768 ? "1.05rem" : "1.3rem",
                      fontFamily: "'EB Garamond', serif",
                      letterSpacing: "1px",
                      fontStyle: "italic",
                    }}
                  >
                    Quick Links
                  </h5>
                </div>
                <ul className="list-style-three">
                  <li>
                    <Link to="/gallery-section/newsletter">Newsletter</Link>
                  </li>
                  <li>
                    <Link to="/gallery-section/advertorial">Advertorial</Link>
                  </li>
                  <li>
                    <Link to="/gallery-section/booklet">Booklet</Link>
                  </li>
                  <li>
                    <Link to="/gallery-section/article">Article</Link>
                  </li>
                  {/* <li>
                    <Link to="/gallery-section/brochure">Brochure</Link>
                  </li> */}
                  <li>
                    <a
                      href="https://www.sarandaforest.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Visit Saranda Forest Division
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.palamautigerreserve.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Visit Palamau Tiger Reserve
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.dalmawildlife.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Visit Dalma Wildlife Sanctuary
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Information */}
            <div className="col">
              <div className="footer-widget footer-contact" style={{
                height: "100%",
                paddingBottom: window.innerWidth <= 768 ? "10px" : "0px",
              }}>
                <div className="footer-title">
                  <h5
                    style={{
                      marginBottom: "15px",
                      fontWeight: "bold",
                      fontSize: window.innerWidth <= 768 ? "1.05rem" : "1.3rem",
                      fontFamily: "'EB Garamond', serif",
                      letterSpacing: "1px",
                      fontStyle: "italic",
                    }}
                  >
                    Contact Us
                  </h5>
                </div>
                <ul className="list-style-one">
                  <li
                    className="jtdc-address"
                    style={{
                      fontSize: window.innerWidth <= 768 ? "14px" : "16px",
                      lineHeight: "1.8",
                      wordBreak: "break-word",
                    }}
                  >
                    <i className="fal fa-map-marker-alt" /> 6th Floor, Premium
                    Suite Building, JUPMI Campus, Plant Plaza Road, Dhurwa,
                    Ranchi - 834004
                  </li>
                  <li>
                    <i className="fal fa-envelope" />{" "}
                    <a href="mailto:jtdcltd@gmail.com" style={{
                      fontSize: window.innerWidth <= 768 ? "14px" : "16px",
                      wordBreak: "break-word",
                    }}>
                      <span style={{ fontWeight: '600' }}>Official email</span>: jtdcltd@gmail.com
                    </a>
                  </li>
                  <li>
                    <i className="fal fa-envelope" />{" "}
                    <a href="mailto:jtdcltd@gmail.com" style={{
                      fontSize: window.innerWidth <= 768 ? "14px" : "16px",
                      wordBreak: "break-word",
                    }}>
                      <span style={{ fontWeight: '600' }}>Support</span>: jtdclhelpdesk@gmail.com
                    </a>
                  </li>
                  <li>
                    <i className="fal fa-phone-volume" />{" "}
                    <a href="tel:+919102403884" style={{
                      fontSize: window.innerWidth <= 768 ? "14px" : "16px",
                      wordBreak: "break-word",
                    }}>
                      +91 9102403884
                    </a>
                  </li>
                  {/* <li><i className="fal fa-clock" /> Mon - Sat, 10 AM - 5 PM</li> */}
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="footer-bottom pt-10 pb-0">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-4 col-md-4">
              <div className="copyright-text text-center text-lg-start">
                <p className="text-white">
                  &copy; 2025 JTDCL, All rights reserved
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 text-center">
              {visitorCount !== null && (
                <div className="visitor-counter" style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  background: 'rgba(255, 179, 71, 0.12)',
                  border: '1px solid rgba(255, 179, 71, 0.3)',
                  borderRadius: '30px',
                  padding: '6px 18px',
                  backdropFilter: 'blur(8px)',
                  WebkitBackdropFilter: 'blur(8px)',
                }}>
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    background: 'rgba(255, 179, 71, 0.2)',
                    animation: 'visitorPulse 2s ease-in-out infinite',
                  }}>
                    <i className="fas fa-eye" style={{
                      color: '#ffb347',
                      fontSize: '13px',
                    }} />
                  </span>
                  <span style={{
                    color: '#ffffff',
                    fontSize: '0.85rem',
                    fontWeight: '500',
                    letterSpacing: '0.5px',
                    fontFamily: "'EB Garamond', serif",
                  }}>
                    <span style={{ color: '#ffb347', fontWeight: '700', fontSize: '1rem' }}>
                      {visitorCount.toLocaleString('en-IN')}
                    </span>
                    {' '}Visitors
                  </span>
                </div>
              )}
            </div>
            <div className="col-lg-4 col-md-4 text-center text-lg-end">
              <ul className="footer-bottom-nav" type="none">
                <li>
                  <a
                    href="/terms-and-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white"
                  >
                    Terms
                  </a>
                </li>
                <li>
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white"
                  >
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* Scroll Top Button */}
          <button className="scroll-top scroll-to-target" data-target="html">
            <img
              src="/assets/images/backgrounds/scroll-up.png"
              alt="Scroll  Up"
              loading="lazy"
            />
          </button>
        </div>
      </div>
      <style>{`
        @keyframes visitorPulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.15); opacity: 0.7; }
        }
      `}</style>
    </footer>
  );
}

export default Newfooter;
